export default __webpack_public_path__ + "static/TragicMarker-181bd625f24211a80ef459931de6d376.ttf";